class MobileMegamenu {
    constructor(cfg) {
        this.cfg = cfg;
        // for every menu
        this.menus = document.querySelectorAll(cfg.menus);
        for (let menu of this.menus) {
            // get the target parent
            let url = menu.querySelector('h3[data-parent]').getAttribute('data-parent');
            let parent = document.querySelector(this.cfg.parent.replace('${url}', url));
            // add toggle controls to the parent link
            let button = document.createElement('button');
            button.innerHTML = 'Show menu items';
            button.className = 'toggle-menu';
            button.addEventListener('click', this.toggle.bind(this, parent, button));
            parent.appendChild(button);
            // copy the menu into the parent
            let clonedMenu = menu.cloneNode(true);
            parent.appendChild(clonedMenu);
        }
    }
    toggle(parent, button, evt) {
        // switch the state of the button
        const isActive = (parent.getAttribute('data-active') == 'true');
        parent.setAttribute('data-active', !isActive);
    }
}

class WishlistTab {
    constructor(cfg) {
        this.cfg = cfg;
        this.clone = null;
        this.container = document.querySelector(cfg.container);
        this.loginPrompt = new LoginPrompt();
        new MutationObserver(this.update.bind(this)).observe(
            this.container, 
            { characterData: true, attributes: false, childList: true, subtree: true }
        );
    }
    update(mutations, observer) {
        // if an existing clone exists
        if (this.clone) {
            // remove it
            document.body.removeChild(this.clone);
            this.clone = null;
        }
        // if the target exists
        const target = this.container.querySelector(this.cfg.watch);
        if (target) {
            // clone the target to the body
            this.clone = target.cloneNode(true);
            document.body.appendChild(this.clone);
            // update the link
            target.setAttribute('href', '/pages/my-specification');
            this.clone.setAttribute('href', '/pages/my-specification');
            // if not logged in, show the popup prompt
            target.addEventListener('click', this.loginCheck.bind(this));
            this.clone.addEventListener('click', this.loginCheck.bind(this));
        }
    }
    // show the login prompt if the user is not logged in
    loginCheck(evt) {
        if (!window.isLoggedIn) {
            evt.preventDefault();
            this.loginPrompt.open();
        }
    }
}

// Wrap Swym API in promises
const swatWrap = {
    cachedLists: {
        time: 0, 
        data: null
    },
    cachedList: {
        time: 0, 
        data: null
    },
    waitUntilReady: function() {
        return new Promise((resolve, reject) => {
            let attempts = 0;
            let interval = setInterval(() => {
                // if the swat API has loaded
                if (typeof _swat !== 'undefined') {
                    console.log(`swym api found after ${attempts} tries`);
                    // cancel the attempts
                    clearInterval(interval);
                    // resolve the promise
                    resolve();
                }
                // retry a number of times
                else if (attempts < 10) { console.log(`swym api not found after ${attempts} tries`); attempts += 1 } 
                // eventually give up
                else { console.log(`giving up on swym api after ${attempts} tries`); reject() }
            }, 500);
        });
    },
    fetchLists: function() {
        return new Promise((resolve, reject) => {
            // return the cached list if still fresh
            const currentTime = new Date().getTime();
            if (currentTime - this.cachedLists.time < 500) {
                resolve(this.cachedLists.data); 
            }
            // or perform a fresh API request
            else {
                _swat.fetchLists({
                    callbackFn: (data) => {
                        const time = new Date().getTime();
                        this.cachedLists = {time, data};
                        resolve(data);
                    },
                    errorFn: (e) => { console.log('failed to fetch lists because:', e); reject(e) }
                });
            }
        });
    },
    fetchListCtx: function(listConfig) {
        return new Promise((resolve, reject) => {
            // return the cached list if still fresh
            const currentTime = new Date().getTime();
            if (currentTime - this.cachedList.time < 500) {
                resolve(this.cachedList.data); 
            }
            // or perform a fresh API request
            else {
                _swat.fetchListCtx(listConfig, 
                    (data) => {
                        const time = new Date().getTime();
                        this.cachedList = {time, data};
                        resolve(data);
                    },
                    (e) => { console.log('failed to fetch list because:', e); reject(e) }
                );
            }
        });
    },
    createList: function(listConfig) {
        return new Promise((resolve, reject) => {
            // perform the API request
            _swat.createList(listConfig,
                (response) => { resolve(response) }, 
                (e) => { console.log('failed to create new list because:', e); reject(e) }
            );
        });
    },
    updateList: function(listConfig) {
        return new Promise((resolve, reject) => {
            // perform the API request
            _swat.updateList(listConfig,
                (response) => { resolve(response) }, 
                (e) => { console.log('failed to update list because:', e); reject(e) }
            );
        });
    },
    shareList: function(listConfig) {
        return new Promise((resolve, reject) => {
            // perform the API request
            _swat.updateList(listConfig,
                (response) => { resolve(response) }, 
                (e) => { console.log('failed to update list because:', e); reject(e) }
            );
        });
    },
    addToList: function(lid, product) {
        return new Promise((resolve, reject) => {
            // perform the API request
            _swat.addToList(lid, product, 
                (response) => { resolve(response) }, 
                (e) => { console.log('failed to add because:', e); reject(e) }
            );
        });
    },
    addProductsToList: function(lid, products) {
        return new Promise((resolve, reject) => {
            // perform the API request
            _swat.addProductsToList(lid, products, 
                (response) => { resolve(response) }, 
                (e) => { console.log('failed to add because:', e); reject(e) }
            );
        });
    },
    updateListItem: function(lid, product) {
        return new Promise((resolve, reject) => {
            // perform the API request
            _swat.updateListItem(lid, product, 
                (response) => { resolve(response) }, 
                (e) => { console.log('failed to update because:', e); reject(e) }
            );
        });
    },
    deleteList: function(lid) {
        return new Promise((resolve, reject) => {
            // perform the API request
            console.log('deleteList', lid, resolve, reject);
            _swat.deleteList(lid, 
                (response) => { resolve(response) }, 
                (e) => { console.log('failed to remove because:', e); reject(e) }
            );
        });
    },
    deleteFromList: function(lid, product) {
        return new Promise((resolve, reject) => {
            // perform the API request
            _swat.deleteFromList(lid, product, 
                (response) => { resolve(response) }, 
                (e) => { console.log('failed to remove because:', e); reject(e) }
            );
        });
    },
    removeProductsFromList: function(lid, products) {
        return new Promise((resolve, reject) => {
            // perform the API request
            _swat.removeProductsFromList(lid, products, 
                (response) => { resolve(response) }, 
                (e) => { console.log('failed to remove because:', e); reject(e) }
            );
        });
    },
    generateSharedListURL: function(lid) {
        return new Promise((resolve, reject) => {
            // perform the API request
            _swat.generateSharedListURL(lid, 
                (response) => { resolve(response) }, 
                (e) => { console.log('failed to get link because:', e); reject(e) }
            );
        });
    },
    sendListViaEmail: function(params) {
        return new Promise((resolve, reject) => {
            // perform the API request
            _swat.sendListViaEmail(params, 
                (response) => { resolve(response) }, 
                (e) => { console.log('failed to send because:', e); reject(e) }
            );
        });
    }
}

class LoginPrompt {
    constructor() {
        this.loginModal = null;
        this.loginTemplate = `
            <section class="suggest-login">
                <div class="modal-overlay"></div>
                <div class="modal-prompt">
                    <header>
                        <h3>Login to create a project</h3>
                        <button class="cancel-choice">Cancel</button>
                    </header>
                    <article>
                        <p>You must login or create an account to add to a spec.</p>
                        <p><a class="button button--primary" href="/account/login">Log in</a></p>
                        <p><a href="/account/register">Create account</a</p>
                    </article>
                </div>
            </section>`;
    }
    open() {
        // build the modal element if needed
        if (!this.loginModal) {
            // build the login modal
            const template = document.createElement('template');
            template.innerHTML = this.loginTemplate;
            // display the list
            document.body.appendChild(template.content);
            this.loginModal = document.querySelector('.suggest-login');
            // add the event handlers
            this.loginModal.querySelector('button.cancel-choice').addEventListener('click', this.close.bind(this));
            this.loginModal.querySelector('.modal-overlay').addEventListener('click', this.close.bind(this));
        }
    }
    close(button, evt) {
        // cancel the form click
        evt?.preventDefault();
        // remove the modal
        document.body.removeChild(this.loginModal);
        this.loginModal = null;
    }
}

class ToggleSpecs {
    constructor(selector) {
        this.selector = selector;
        this.updateTimeout = null;
        this.init();
    }
    init() {
        // add the specs features
        this.update();
        // re-apply the specs features every time Boost removes them
        this.observer = new MutationObserver(this.update.bind(this));
        this.observer.observe(
            document.getElementById('html-body'), 
            { attributes: true, childList: true, subtree: true }
        );
    }
    async update() {
        clearTimeout(this.updateTimeout);
        this.updateTimeout = setTimeout(async () => {
            console.log('updating specs functionality after Boost rewrite');
            // fetch the lists
            if (typeof _swat !== 'undefined') {
                const lists = await window.swatWrap.fetchLists();
                let total = 0;
                for (let list of lists) {
                    total += list.listcontents.length;
                }
                // restore the product count it it's disappeared
                const launcherElement = document.querySelector('.swym-header-launcher');
                const counterElement = launcherElement.querySelector('.swym-header-launcher-badge');
                if (launcherElement && !counterElement) {
                    const counterHtml = `<span class="swym-header-launcher-badge cart-count-bubble" tabindex="0" role="button" style="left: 1.5rem;"><span class="swym-header-launcher-count " tabindex="0" role="button">${total}</span></span>`;
                    const template = document.createElement('template');
                    template.innerHTML = counterHtml;
                    launcherElement.appendChild(template.content);
                }
                // update the product count
                const counterOutput = document.querySelector('.swym-header-launcher-count');
                console.log('showing total wishlist items:', total);
                if (counterOutput && counterOutput.innerHTML !== total + '') counterOutput.innerHTML = total;
            }
            // start all the spec toggles
            const containers = document.querySelectorAll(this.selector);
            for (let container  of containers) {
                if (!container.hasAttribute('data-done')) {
                    container.setAttribute('data-done', '');
                    new ToggleSpec(container);
                }
            }
        }, 500);
    }
}

class ToggleSpec {
    constructor(container) {
        // store the UI elements
        this.container = container;
        this.listModal = null;
        this.loginPrompt = new LoginPrompt();
        this.addButton = this.container.querySelector('.action.add');
        this.removeButton = this.container.querySelector('.action.remove');
        this.empiInput = this.container.querySelector('[name="empi"], [name="product-id"]');
        this.epiInput = this.container.querySelector('[name="epi"], [name="id"]');
        this.duInput = this.container.querySelector('[name="du"]');
        this.qtyInput = this.container.querySelector('[name="quantity"]');
        // define the markup of the list modal
        this.listTemplate = `
            <form class="select-wish-list">
                <div class="modal-overlay"></div>
                <div class="modal-prompt">
                    <header>
                        <h3>Pick a project</h3>
                        <button class="cancel-choice">Cancel</button>
                        <div class="modal-error"></div>
                    </header>
                    <div class="modal-response">
                        <ul>{existing}</ul>
                        <fieldset>
                            <label>
                                <span>Create a project</span>
                                <input name="title" type="text" placeholder=" " required/>
                            </label>
                            <button class="new-list" type="submit">Create</button>
                        </fieldset>
                    </div>
                </div>
            </form>`;
        this.itemTemplate = `<li><button data-lid="{lid}">{lname}</button></li>`;
        this.completedTemplate = `
            <article>
                <p>The item was added to the {lname} list.</p>
            </article>
            <footer>
                <button class="button button--primary close">Continue</button>
                <a href="/pages/my-specification" class="button button--secondary specs">My Specification</a>
            </footer>
            `;
        // add the event handlers
        this.addButton.addEventListener('click', this.onAddProduct.bind(this));
        this.removeButton.addEventListener('click', this.onRemoveProduct.bind(this));
        this.epiInput.addEventListener('change', this.redraw.bind(this));
        // update the interface
        this.redraw();
    }
    async redraw() {
        // check if the item is on the list
        const lists = await this.checkIfOnList();
        // adjust the added status
        if (lists?.length > 0) { this.container.setAttribute('data-added', '') }
        else { this.container.removeAttribute('data-added') }
    }
    async checkIfOnList() {
        // get the product id
        let empi = this.empiInput.value;
        let epi = this.epiInput.value;
        let du = window.location.origin + this.duInput.value;
        // fetch the lists
        const lists = await window.swatWrap.fetchLists();
        // for every list
        const foundItems = [];
        for (let list of lists) {
            // for every item
            for (let listcontent of list.listcontents) {
                // if the product is on this list
                if (empi == listcontent.empi && epi == listcontent.epi && listcontent.du.includes(du)) {
                    // tally its presence
                    foundItems.push({
                        lid: list.lid,
                        lname: list.lname,
                        empi: listcontent.empi,
                        epi: listcontent.epi,
                        du: listcontent.du,
                        note: listcontent.note,
                        cprops: listcontent.cprops,
                        qty: listcontent.qty
                    });
                }
            }
        }
        // could not be found
        return foundItems;
    }
    async onAddProduct(evt) {
        // cancel the form click
        evt?.preventDefault();
        // if the user is logged in
        if (window.isLoggedIn) {
            // fetch the lists
            const lists = await window.swatWrap.fetchLists();
            // if there are no lists
            if (lists.length == 0) {
                // create a default list
                await window.swatWrap.createList({lname: 'Default_20250709'})
            }
            // ask which list to use
            this.chooseList(lists);
        }
        // otherwise make the user log in
        else {
            this.loginPrompt.open();
        }
    }
    async onRemoveProduct(evt) {
        // cancel the form click
       evt?.preventDefault();
        // remove the item from the lists
        const lists = await this.checkIfOnList();
        for (let list of lists) {
            await window.swatWrap.deleteFromList(list.lid, {
                empi: list.empi, 
                epi: list.epi, 
                du: list.du
            });
        }
        // remove the added status of the card
        this.container.removeAttribute('data-added');
    }
    chooseList(lists) {
        // build the modal element if needed
        if (!this.listModal) {
            // build the list modal
            const template = document.createElement('template');
            let itemsHTML = '';
            for (let list of lists) {
                // if this is not the default list
                if (list.lname != 'Default_20250709' && list.lname != 'My Specification') {
                    // add the list entry to the modal
                    itemsHTML += this.itemTemplate.replace('{lid}', list.lid).replace('{lname}', list.lname);
                }
            }
            let listHTML = this.listTemplate.replace('{existing}', itemsHTML);
            template.innerHTML = listHTML;
            // display the list
            document.body.appendChild(template.content);
            this.listModal = document.querySelector('.select-wish-list');
            // get the UI elements
            const titleInput = this.listModal.querySelector('input[name="title"]');
            const addButton = this.listModal.querySelector('button.new-list');
            const cancelButton = this.listModal.querySelector('button.cancel-choice');
            // add the event handlers
            this.listModal.addEventListener('submit', this.onNewList.bind(this));
            titleInput.addEventListener('keydown', (evt) => { if (evt.code === 'Enter') { this.onNewList(evt) } });
            addButton.addEventListener('click', this.onNewList.bind(this, addButton));
            cancelButton.addEventListener('click', this.onCloseList.bind(this, cancelButton));
            this.listModal.querySelector('.modal-overlay').addEventListener('click', this.onCloseList.bind(this));
            const lidButtons = this.listModal.querySelectorAll('button[data-lid]');
            for (let lidButton of lidButtons) {
                lidButton.addEventListener('click', this.onSelectList.bind(this, lidButton.getAttribute('data-lid'), lidButton.innerHTML, lidButton));
            }
        }
    }
    onCloseList(button, evt) {
        // cancel the form click
        evt?.preventDefault();
        // remove the modal
        document.body.removeChild(this.listModal);
        this.listModal = null;
    }
    async onSelectList(lid, lname, button, evt) {
        // cancel the form click
        evt?.preventDefault();
        // show the busy indicator
        button.setAttribute('disabled', '');
        button.setAttribute('data-busy', '');
        // check if the product is already on the list
        const lists = await this.checkIfOnList();
        const found = lists.find((list) => list.lid == lid);
        const empi = this.empiInput.value;
        const epi = this.epiInput.value;
        const du = window.location.origin + this.duInput.value;
        const note = found?.note || [];
        const cprops = found?.cprops || {"vqty":[], "room":[]};
        let qty = found?.qty || 0;
        // add any prefered quantity
        qty += (this.qtyInput) ? +this.qtyInput.value : 1;
        // try to add the item to the list
        try {
            // if the item is already on the list
            if (found) {
                await window.swatWrap.updateListItem(lid, {epi, empi, du, qty, note, cprops})
            }
            // otherwise add the item to the list
            else {
                await window.swatWrap.addToList(lid, {epi, empi, du, qty, note, cprops})
            }
            // close the list if the product was successfully added
            this.container.setAttribute('data-added', ''); 
            // replace the form with a confirmation message
            this.listModal.querySelector('.modal-response').innerHTML = this.completedTemplate.replace('{lname}', lname);
            this.listModal.querySelector('button.close').addEventListener('click', this.onCloseList.bind(this));
        }
        // or report the error
        catch(e) { this.listModal.querySelector('.modal-error').innerHTML = e || 'Error adding to list.' }
        // remove the busy indicator
        button.removeAttribute('disabled');
        button.removeAttribute('data-busy');
    }
    async onNewList(button, evt) {
        // cancel the form click
        evt?.preventDefault();
        // show the busy indicator
        button.setAttribute('disabled', '');
        button.setAttribute('data-busy', '');
        // create the new list
        const lnameInput = this.listModal.querySelector('[name="title"]');
        try {
            const newList = await window.swatWrap.createList({lname: lnameInput.value});
            // if the list was successfully created
            if (newList?.lid) {
                // fetch the lists
                const lists = await window.swatWrap.fetchLists();
                // reset the modal;
                this.onCloseList();
                this.chooseList(lists);
            }
        }
        // or report the error
        catch(e) { this.listModal.querySelector('.modal-error').innerHTML = e || 'Error adding to list.' }
        // remove the busy indicator
        button.removeAttribute('disabled');
        button.removeAttribute('data-busy');
    }
}

window.swatWrap = swatWrap;

window.toggleSpecs = ToggleSpecs; 

window.ToggleSpec = ToggleSpec; 

document.addEventListener("DOMContentLoaded", () => {

    // if Boost is present use their variant
    if (window.boostWidgetIntegration) {
        console.log('using boost integration for ToggleSpecs');
        window.toggleSpecs = new ToggleSpecs('.boost-sd__product-item .boost-sd_product-info-toggle[data-sku]');
    }
    // otherwise use the default
    else {
        console.log('using default ToggleSpecs');
        window.toggleSpecs = new ToggleSpecs('.product-card-wrapper[data-sku]');
    }

    window.mobileMegamenu = new MobileMegamenu({
        "menus": ".explore-enware-products [data-context=\"megamenu\"]:has(h3[data-parent])",
        "parent": ".menu-drawer nav > ul > li:has(a[href=\"${url}\"])"
    });

    window.wishlistTab = new WishlistTab({
        "container": ".header__icons",
        "watch": ".swym-header-launcher"
    });

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function(swat) {
        // Define the event
        let event = 'sw:addedtowishlist';

        // Define the listener
        let listener = function(e) {
            var data = e.detail.d;
            //console.log("YAY! Added the product to wishlist", data);

            // Call Gadget webhook
            fetch("https://enware-swym-wishlist-webhook.gadget.app/wishlistWebhook", {
                method: "POST",
                mode: "no-cors",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
            })
            .then(res => res.json())
            .then(resp => {
                console.log("Sent to Gadget webhook:", resp);
            })
            .catch(err => {
                console.error("Error sending to Gadget webhook:", err);
            });

        };

        // Attach listener
        swat.evtLayer.addEventListener(event, listener);
    });

});